import { useContext } from "react";
import { useProposalMode } from "@services/collections/assignment-proposal/assignmentProposalServices";
import { AppContext } from "../context/EditSessionsContext";
import type { TypeAssignment } from "../context/formData.reducer";
import { getProposalChangedDimensions } from "../utils/proposalChangedDimensions";
import { useActiveProposal } from "./useActiveProposal";

/**
 * Whether a section of the form shows the "Solicitud de cambio" pill: the editor is bound to a
 * saved proposal (opened from the Drawer, or saved or sent in this visit) and at least one of the
 * selected sessions has, in that section, a value that differs from the persisted one. A new
 * proposal that was never saved has no pill, and neither has the editor outside proposal mode.
 */
export const useProposalSectionChanged = (type: TypeAssignment | undefined): boolean => {
  const { state } = useContext(AppContext);
  const { isProposalMode } = useProposalMode();
  const activeProposal = useActiveProposal();

  if (!type || !isProposalMode || !activeProposal) return false;

  return (state?.form?.selectedSessions ?? []).some(
    session => getProposalChangedDimensions(session, state.form)[type],
  );
};
